/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'

/** Common Components */
import ToolbarButtons from '../../../../components/toolbarButtons/ToolbarButtons';

/** Configuration */
import { AQpoToolbarConfig, AQpoToolbarDeleteBtnConfig } from '../../AcquisitionpoToolbarConfig';
import Acquisitions from '../../Acquisitions';
import CustomCenterModel from '../../../../components/ui/customCenterModel/CustomCenterModel';
import { AppIcons } from '../../../../data/appIcons';

/** Lazily Loaded Component */
const AcquisitionsPurchaseOrderDetails = React.lazy(() => (import('./Acquisitions PurchaseOrderDetails/AcquisitionsPurchaseOrderDetails')));
const Acquisitionsfilter = React.lazy(() => (import('../Acquisitions.filter')));

const ManageAcquisitionsSupplierPO = () => {
  const [isModelOpen, setIsModelOpen] = useState(false);

  const handleSaveClick = () => {
    alert("Save PO");
  }
  const handleDeleteClick = () => {
    alert("Delete PO");
  }

  const handleAddClick = () => {
    setIsModelOpen(true)
  }

  const handleCloseModel = () => {
    setIsModelOpen(false);
  };

  const handleActionClick = (action) => {
    switch (action) {
      case "NEW":
        handleAddClick();
        break;
      case "SAVE":
        handleSaveClick();
        break;
      case "DELETE":
        handleDeleteClick()
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <div className="toolbar-section mx-1 mb-2">
        <ToolbarButtons
          toolbarConfiguration={AQpoToolbarConfig}
          onActionClick={handleActionClick}
        //  isLoading={isUpdating}
        />
      </div>
      <Acquisitionsfilter />
      <AcquisitionsPurchaseOrderDetails />
      <div className="leftbottomsection-deletebtn fixed-btn">
        <ToolbarButtons
          toolbarConfiguration={AQpoToolbarDeleteBtnConfig}
          onActionClick={handleActionClick}
        />
      </div>
      <div>
        <CustomCenterModel
          isOpen={isModelOpen}
          useCustomBg={true}
          modalTitle={`New Acquisition Supplier PO`}
          contentClass='content-50'
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
        />
      </div>
    </div>

  )
}

export default Acquisitions(ManageAcquisitionsSupplierPO);